/* eslint-disable indent */
import { useEffect, useState } from 'react';
import { getDisplayValue } from '../../../utils/formatName';
import i18n from '../../../i18';

export const useFilterOptions = (
    contextFields = [],
    itemsFields = [],
    controllersData,
    server
) => {
    const [filterOptions, setFilterOptions] = useState({});

    useEffect(() => {
        const loadContextData = async (field) => {
            const { filterBy, display, needTranslate } = field;
            if (!filterBy || filterOptions[filterBy]) return;

            if (controllersData[filterBy]) {
                setFilterOptions((prev) => ({
                    ...prev,
                    [filterBy]: controllersData[filterBy].map((item) => ({
                        ...item,
                        name: display
                            ? getDisplayValue(item, field)
                            : item.name,
                        filterKey: field.filterKey || 'id',
                        needTranslate: needTranslate
                    }))
                }));
            } else {
                try {
                    const res = await server[filterBy].getAll();
                    if (res.error !== 'OK') {
                        return;
                    }
                    setFilterOptions((prev) => ({
                        ...prev,
                        [filterBy]: res.data.map((item) => ({
                            ...item,
                            name: display
                                ? getDisplayValue(item, field)
                                : item.name,
                            filterKey: field.filterKey || 'id',
                            needTranslate: needTranslate
                        }))
                    }));
                } catch (error) {
                    console.error(
                        `Failed to load data for ${filterBy}:`,
                        error
                    );
                }
            }
        };

        if (contextFields.length > 0) {
            contextFields.forEach((field) => loadContextData(field));
        }

        if (itemsFields.length > 0) {
            itemsFields.forEach((field) => {
                const mappedItems =
                    field.items.map((item) => {
                        if (field.cell === 'Entity') {
                            return {
                                id: item.id,
                                name: item.name,
                                filterKey: field.filterKey || 'id',
                                needTranslate: field.needTranslate
                            };
                        }
                        return {
                            id: item,
                            name: item,
                            filterKey: field.filterKey || 'id',
                            needTranslate: field.needTranslate
                        };
                    }) || [];

                // Sort provinces alphabetically by name
                const sortedItems =
                    field.filterBy === 'province'
                        ? [...mappedItems].sort((a, b) => {
                              return a.name.localeCompare(
                                  b.name,
                                  i18n.language || 'en',
                                  {
                                      sensitivity: 'base',
                                      numeric: true
                                  }
                              );
                          })
                        : mappedItems;

                setFilterOptions((prev) => ({
                    ...prev,
                    [field.filterBy]: sortedItems
                }));
            });
        }
    }, [contextFields, itemsFields, controllersData, server]);

    return filterOptions;
};
